import RouterAuth from "./RouterAuth";
export default RouterAuth;
